import { Injectable } from '@angular/core';

@Injectable()
export class ScrollService {
  constructor() {}

  /**
   * Make a scrollTop 'animated'
   */
  public scrollToTop() {
    let initialPosition =
      document.documentElement.scrollTop ||
      window.pageYOffset ||
      document.body.scrollTop ||
      0;
    const interval = setInterval(() => {
      initialPosition = initialPosition - 300;
      if (initialPosition <= 0) {
        this.setScrollToTop(0);
        clearInterval(interval);
      } else {
        this.setScrollToTop(initialPosition);
      }
    }, 50);
  }

  private setScrollToTop(initialPosition) {
    if (document.documentElement && document.documentElement.scrollTop) {
      document.documentElement.scrollTop = initialPosition;
    } else {
      if (window.pageYOffset) {
        (<any>window).pageYOffset = initialPosition;
      } else {
        if (document.body.scrollTop) {
          document.body.scrollTop = initialPosition;
        }
      }
    }
  }

  public scrollToElement(
    fromSelector,
    toSelector,
    offset?,
    time?: number,
    callback?: Function,
  ) {
    const fromElementPosition = this.getCoords(fromSelector);
    const toElementPosition = this.getCoords(toSelector);
    if (fromElementPosition && toElementPosition) {
      let value = fromElementPosition.top;
      let final = toElementPosition.top;

      const multi = fromElementPosition.top < toElementPosition.top ? 1 : -1;

      if (offset) {
        final -= offset;
      }

      const interval = setInterval(
        () => {
          window.scrollTo(0, value);
          value = value + 50 * multi;
          if ((value >= final && multi === 1) || (value <= final && multi === -1)) {
            clearInterval(interval);
            if (callback) {
              callback();
            }
          }
        },
        time ? time : 50,
      );
    }
  }

  private getCoords(selector) {
    // crossbrowser version
    const elem = document.querySelector(selector);
    if (elem) {
      const box = elem.getBoundingClientRect();
      const body = document.body;
      const docEl = document.documentElement;
      const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
      const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
      const clientTop = docEl.clientTop || body.clientTop || 0;
      const clientLeft = docEl.clientLeft || body.clientLeft || 0;
      const top = box.top + scrollTop - clientTop;
      const left = box.left + scrollLeft - clientLeft;
      return { top: Math.round(top), left: Math.round(left) };
    }
    return null;
  }
}
